import React, { Component } from "react";
import DisputeFormView from "./dispute-form-view.component";
import {Milestone} from "../../../../common/milestone/milestone.component";
import  ModalForm from "../../../../common/modal/form-modal/modal-form.component";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { disputeFollowUpAction } from "../../../../../store/external/invoice/dispute/dispute-followup.reducer";
import { Loading } from "../../../../common/loading";
import { actions } from 'react-redux-form';
import store from '../../../../../store';
import { FOLLOWUP_DETAILS, MILESTONE } from "../../../../../constants/external-constants";
import { convertToLocalDateToUTCDate } from "../../../../../utils/helpers.utils";
class DisputeFormContainer extends Component{
    constructor(props){
        super(props);
        this.state={
            activeIndex: props.disputeDetailsId > 0 ? -1 : -2,
            modalShow:false,
            modalTitle:"",
            textLabel:"",
            dateLabel:"",
            isLoading: true,
            dataLoading: true,
            minDate:null,
            maxDate:null
        }
    }

    //put your business logic or calculations here
    // use FormView for UI display only

    componentDidUpdate(prevProps) {
        if (prevProps.invoiceDisputeFollowUpDetails !== this.props.invoiceDisputeFollowUpDetails && this.props.disputeDetailsId > 0 
           || prevProps.invoiceDisputeDetailsForm !== this.props.invoiceDisputeDetailsForm && this.props.invoiceDisputeDetailsForm.id > 0) {
            const { disputeFollowUpDetails } = this.props.invoiceDisputeFollowUpDetails;

            const firstMissingIndex = FOLLOWUP_DETAILS.findIndex(detail =>
                !disputeFollowUpDetails.some(f => f.Type === detail.type)
            );

            const activeIndex = firstMissingIndex === -1 ? FOLLOWUP_DETAILS.length - 1 : firstMissingIndex - 1;

            this.setState({ activeIndex });
            return
        }
    }


    componentDidMount(){     
      this.fetchFollowUpDetails();
    }

    fetchFollowUpDetails=()=>{
        const { getFollowUpDetailsById, disputeDetailsId } = this.props;
        getFollowUpDetailsById(disputeDetailsId).then(()=>{
            this.setState({isLoading: false})
        })
    }

    handleClickAction = (id) => {           
        const { getFollowUpDetailsByType, disputeDetailsId } = this.props;
        const { disputeFollowUpDetails } = this.props.invoiceDisputeFollowUpDetails;

        const followUp = FOLLOWUP_DETAILS[id];  
        let minDate = null;
        if (id > 0) {
            const folloUpData = disputeFollowUpDetails
                .filter(f => f.Type===FOLLOWUP_DETAILS[id-1].type)
    
            if (folloUpData.length > 0) {
                minDate = convertToLocalDateToUTCDate(new Date(folloUpData[0].FollowUpDate), false);
            }
        }
    
        this.setState({minDate, maxDate: new Date()});
        if (followUp) {
            getFollowUpDetailsByType(disputeDetailsId, followUp.type).then(()=>{
                this.setState({dataLoading:false})
            })
            store.dispatch(actions.change('invoiceDisputeFollowUpForm.type', followUp.type));
            store.dispatch(actions.change('invoiceDisputeFollowUpForm.disputeId', disputeDetailsId));      
            this.setState({
                modalTitle: followUp.title,
                textLabel: followUp.textLabel,
                dateLabel: followUp.dateLabel,
                modalShow: true
            });
        }
    };
    

    handleCloseNotif = () =>{
        this.setState({modalShow:false, dataLoading:true});
    }

    handleSaveDetails = async () => {
        const { saveFollowUpDetails } = this.props;
        this.setState({ dataLoading: true });
    
        try {
            await saveFollowUpDetails();
            await this.fetchFollowUpDetails();
        } finally {
            this.setState({ dataLoading: false });
            this.handleCloseNotif();
        }
    };
    

    render() {
        const { disputeDetailsId, invoiceDisputeFollowUpForm, roles, invoiceAuditId } = this.props;    
        const { detailsFound } = this.props.invoiceDisputeFollowUpDetails;
        if(this.state.isLoading) {
           return <Loading />
        }   
        return (
        <>
            <ModalForm handleModal={this.handleCloseNotif} dataLoading={this.state.dataLoading} existing={detailsFound}  textLabel={this.state.textLabel} {...roles} 
            dateLabel={this.state.dateLabel} title={this.state.modalTitle} show={this.state.modalShow} 
            followUpDetails={invoiceDisputeFollowUpForm.details} detailsFieldProps="invoiceDisputeFollowUpForm.details" 
            followUpDate={invoiceDisputeFollowUpForm.followUpDate} dateFieldProps="invoiceDisputeFollowUpForm.followUpDate" SaveDetails={this.handleSaveDetails.bind(this)}
            minDate={this.state.minDate} maxDate={this.state.maxDate}/>

            <Milestone containerClass="form-details-container" handleAction={this.handleClickAction} milestonesLabel="follow_up" milestones={MILESTONE} icon={'flag-solid'} activeIndex={this.state.activeIndex} {...roles}/>
           
                <DisputeFormView disputeDetailsId={disputeDetailsId} invoiceAuditId={invoiceAuditId} {...roles} />
        </>
        )
    }

}

export default connect(
    state => {
        const { 
            disputeFollowUpDetails, invoiceDisputeFollowUpDetails,
            form: { forms: { invoiceDisputeFollowUpForm: { $form } } }
        } = state;
       
        const { invoiceDisputeFollowUpForm, invoiceDisputeDetailsForm } = state.form
        return {
            disputeFollowUpDetails,
            invoiceDisputeFollowUpDetails,
            invoiceDisputeFollowUpForm,
            invoiceDisputeDetailsForm,
            $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeFollowUpAction),
        dispatch
    )  
)(DisputeFormContainer);